import styled from 'styled-components'

import { useGetRecommendsData, useUpdateRecommendsMan } from 'src/services/hooks/useFetchRecommends'
import useLoading from 'src/components/layouts/hooks/useLoading'

import StandardPageWrapper from 'src/components/common/StandardPageWrapper'
import { MainLayout } from 'src/components/layouts/MainLayout'
import TalentGroup from 'src/components/myPage/recommend/TalentGroup'
import Loading from 'src/components/layouts/Loading'
import { Tab } from '@headlessui/react'
import { Wrapper } from 'src/components/common/Wrapper'

import { GROUP } from 'src/constants/group'
import { RECOMMEND_TALENT } from 'src/constants/characters'
import GradientHeader from 'src/components/common/GradientHeader'

const GroupType = styled.h3.attrs({
  className:
    'pt-2.5 pb-2 bg-talent-group-header w-full font-outfit text-[#6F9BFF] text-2xl leading-[22px] uppercase font-bold drop-shadow-talent-group-header'
})``

export const RecommendPage = () => {
  const { data: recommends, isLoading } = useGetRecommendsData()
  const mutation = useUpdateRecommendsMan()

  const processedRecommends =
    recommends
      ?.map((apiItem) => {
        const matchedTalent = RECOMMEND_TALENT.find((talent) => talent.name === apiItem.name)
        const groupNameFromTalent = matchedTalent?.group
        const matchedGroup = GROUP.find((group) => group.name === groupNameFromTalent)
        return {
          ...apiItem,
          group: groupNameFromTalent,
          japaneseName: matchedGroup?.japaneseName,
          groupLogo: matchedGroup?.groupLogo,
          ...matchedTalent
        }
      })
      .filter((item) => item.group && item.name) || []

  const membersByGroup = processedRecommends.reduce((acc, item) => {
    const groupName = item.group
    if (groupName) {
      if (!acc[groupName]) {
        const originalGroup = GROUP.find((g) => g.name === groupName)
        acc[groupName] = {
          group: groupName,
          japanesename: originalGroup?.japaneseName,
          groupLogo: originalGroup?.groupLogo,
          members: []
        }
      }
      acc[groupName].members.push(item)
    }
    return acc
  }, {})

  const orderedResult = GROUP.reduce(
    (acc, groupConst) => {
      const groupData = membersByGroup[groupConst.name]

      if (groupData && groupData.members.length > 0) {
        const displayGroupData = {
          ...groupData,
          group: groupConst.name,
          japanesename: groupConst.japaneseName,
          groupLogo: groupConst.groupLogo
        }

        if (groupData.members.length > 1 && groupConst.name !== 'solo') {
          acc.group.push(displayGroupData)
        } else {
          acc.solo.push(displayGroupData)
        }
      }
      return acc
    },
    { group: [], solo: [] }
  )

  const handleUpdateRecommendMan = (id) => {
    mutation.mutate(id)
  }

  const { showLoading, progress } = useLoading([isLoading, mutation.isLoading])
  if (showLoading || isLoading || mutation.isLoading) {
    return (
      <Wrapper>
        <Loading progress={progress} />
      </Wrapper>
    )
  }

  return (
    <MainLayout
      className="relative h-fit"
      active="mypage"
      classNameHeader="!bg-gradient-sky-to-pink"
    >
      <StandardPageWrapper className="bg-white h-full" overflow={true}>
        <div className="mt-10">
          <Tab.Group>
            <GradientHeader title="TALENT" />
          </Tab.Group>
        </div>
        <div className="space-y-10 overflow-y-auto h-[calc(100dvh-200px)] hidden-scroll">
          {orderedResult.group.length > 0 && (
            <div className="space-y-3">
              <GroupType>GROUP</GroupType>
              {orderedResult.group.map((group) => (
                <TalentGroup
                  characterList={group.members}
                  logo={group.groupLogo}
                  key={group.group}
                  handleUpdateRecommendMan={handleUpdateRecommendMan}
                />
              ))}
            </div>
          )}
          {orderedResult.solo.length > 0 && (
            <div className="space-y-3">
              <GroupType>SOLO</GroupType>
              {orderedResult.solo.map((group) => (
                <TalentGroup
                  characterList={group.members}
                  logo={group.groupLogo}
                  key={group.group}
                  handleUpdateRecommendMan={handleUpdateRecommendMan}
                />
              ))}
            </div>
          )}
        </div>
      </StandardPageWrapper>
    </MainLayout>
  )
}
